import React from 'react';
import { PivotPanel } from './components/PivotPanel';
export function App() {
  return <div className="flex w-full min-h-screen justify-center items-center bg-gray-100 p-4" data-id="element-0">
      <PivotPanel data-id="element-1" />
    </div>;
}